import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import { clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    loading: false,
    asset: null
};

const route = "modules/driverPerformance/views/events/modals/assetInfo/redux/slice";

export const getAsset = createAsyncThunk("driverPerformance/eventTab/getAsset", async (payload, { rejectWithValue }) => {
    const { id } = payload
    try {

        const response = await clientQuery(
            `
                query getUnit ($id: Int!) {
                    data: getUnit (id: $id) {
                        id
                        label
                        asset {
                            id
                            label
                            tagIds
                            tags {
                                id
                                label
                                color
                            }
                        }
                    }
                }
            `,
            {
                id
            },
            endpoints.GRAPHQL_GENERAL_V2
        );
        return response?.data
    } catch (exc) {
        ExceptionManager(exc, route, "getAsset");
        return rejectWithValue(exc);
    }
});

//Slice
const driverPerformanceEventsTabAssetInfoRedux = createSlice({
    name: "driverPerformance/assetInfo",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //getAsset
        builder.addCase(getAsset.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getAsset.fulfilled, (state, action) => {
            state.loading = false;
            state.asset = action.payload
        });
        builder.addCase(getAsset.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceEventsTabAssetInfoRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
